export default __webpack_public_path__ + "static/media/ilmoitus.4361c5ad.svg";